const t = "_textContainer_1pq68_1", e = "_is2Liner_1pq68_6", n = "_content_1pq68_10", o = "_freeText_1pq68_17", _ = "_withCTA_1pq68_21", c = "_calloutText_1pq68_24", i = "_icon_1pq68_28", s = {
  textContainer: t,
  is2Liner: e,
  content: n,
  freeText: o,
  withCTA: _,
  calloutText: c,
  icon: i
};
export {
  c as calloutText,
  n as content,
  s as default,
  o as freeText,
  i as icon,
  e as is2Liner,
  t as textContainer,
  _ as withCTA
};
//# sourceMappingURL=index.es656.js.map
